import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import isoWeekYear from 'dayjs/plugin/isoWeeksInYear'
import weekday from 'dayjs/plugin/weekday'

import 'dayjs/locale/zh-cn'

// config dayjs
dayjs.extend(isoWeek)
dayjs.extend(isoWeekYear)
dayjs.extend(weekday)
dayjs.locale('zh-cn')

export default dayjs
